// extracted by mini-css-extract-plugin
export default {"wrapper":"Switcher_wrapper__-uolL","item":"Switcher_item__OjQ++","itemActive":"Switcher_itemActive__An1sZ","icon":"Switcher_icon__oV4va","compact":"Switcher_compact__GJRZy"};